import { OidcUrlHelper } from '@ori/auth';
import ReactDOM from 'react-dom';

import { App } from './App';
import type { AppConfiguration } from './types';

// eslint-disable-next-line complexity -- nevermind
export const render = (rootElement: HTMLElement): void => {
  // extract token from URL; only on dev machine, not needed elsewhere
  if (__DEV__) {
    const searchParams = new URLSearchParams(window.location.hash.split('?')[1]);

    if (searchParams.has('state')) {
      const oidcUrlHelper = new OidcUrlHelper();

      oidcUrlHelper.storeTokenFromParams(searchParams);
    }
  }

  const settings = JSON.parse(rootElement.dataset.settings ?? '{}');
  const configuration: AppConfiguration = {
    apiUrl: rootElement.dataset.apiUrl ?? '',
    graphqlUrl: `${rootElement.dataset.graphqlUrl ?? ''}graphql`,
    identityUrl: rootElement.dataset.identityUrl ?? '',
    appUrl: rootElement.dataset.appUrl ?? '',
    tenant: rootElement.dataset.tenant ?? '',
    orgId: settings.OrganizationId ?? '',
    deploymentId: settings.DeploymentId ?? '',
    dataURL: settings.DataURL ?? '',
    queue: settings.Queue ?? '',
    firstName: settings.FirstName ?? '',
    lastName: settings.LastName ?? '',
    email: settings.Email ?? '',
    customerId: Number.parseInt(rootElement.dataset.customerId ?? '-1', 10),
    scriptPath: settings.ScriptURL ?? '',
    pluginsPath: settings.PluginsPath ?? '',
    title: settings.Title ?? '',
    consultantNumber: Number.parseInt(settings.ConsultantNumber ?? 0, 10),
    phoneNumber: settings.PhoneNumber,
    language: settings.Language ?? 'pl',
    buttonLabel: settings.ButtonLabel ?? 'Chat with us',
    dedicatedPage: !!settings.DedicatedPage,
    maxMessageLength: 500,
  };

  if (configuration.dedicatedPage) {
    // @ts-expect-error
    import('./styles/theme-ori-dedicated.less');
  } else {
    // @ts-expect-error
    import('./styles/theme-ori-light.less');
  }
  ReactDOM.render(<App configuration={configuration} />, rootElement);
};
